const initialStateTeacherResults = {
  loading: false,
  error: null,
  result: [
    {
      id: null,
      studentname: null,
      studentemail: null,
      classes: [
        {
          classId: 0,
          className: null,
          schoolId: 0,
          schoolName: null,
          active: false
        }
      ],
      courses: [],
      status: null,
      score: 0,
      activityPoints: 0,
      lastRun: null,
      courseName: null,
      courseId: 0,
      module: null,
      moduleId: 0,
      maxScore: 0,
      approveLimit: 0,
      maxActivityPoints: 0,
      isFinalExam: false,
      studentIsDone: false,
      studentHasPassed: false
    }
  ],
  statusCode: null
};

export function teacherResultsReducer(
  state = initialStateTeacherResults,
  action
) {
  switch (action.type) {
    case "FETCH_TEACHER_RESULTS_BEGIN": {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case "FETCH_TEACHER_RESULTS_SUCCESS": {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    case "FETCH_TEACHER_RESULTS_FAILURE": {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        result: []
      };
    }
    default:
      return state;
  }
}
